import React, { useEffect, useState } from "react";
import { BiChevronLeft, BiMinusCircle } from "react-icons/bi";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router";
import {
  deleteProduct,
  editProduct,
  getCategories,
  getProduct,
} from "../../api/product";
import UploadImages from "./upload";

const ViewProduct = () => {
  const { id } = useParams();
  const { data: productData, isLoading } = useQuery(
    ["single-product", id],
    () => getProduct(id)
  );
  const { data } = useQuery("categories", getCategories);

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [images, setImages] = useState([]);
  const [variants, setVariants] = useState([
    { name: "", value: "", quantity: 0 },
  ]);

  const formData = [
    {
      title: "Product Name",
      name: "title",
      placeholder: "e.g John",
      type: 1,
      defaultValue: productData?.title,
    },
    {
      title: "Category",
      name: "category_id",
      placeholder: "e.g John",
      options: data || [],
      type: 2,
      defaultValue: productData?.category_id,
    },
    {
      title: "Price",
      name: "price",
      placeholder: "1000",
      type: 1,
      defaultValue: productData?.price,
    },
    {
      title: "Stocks",
      name: "stock",
      placeholder: "e.g 10",
      type: 1,
      defaultValue: productData?.stock,
    },
    {
      title: "Description",
      name: "description",
      placeholder: "e.g John",
      type: 3,
      defaultValue: productData?.description,
    },
  ];

  useEffect(() => {
    if (productData?.variants) {
      setVariants(productData?.variants);
    }
  }, [productData?.variants]);

  const mutation = useMutation(editProduct, {
    onSuccess: () => {
      showSuccessToast("Product edited successfully");
      queryClient.invalidateQueries("products");
      window.location.href = "/products";
    },
    onError: (e) => {
      showErrorToast(e.message);
    },
  });

  const deleteMutation = useMutation(deleteProduct);

  const onFinish = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const category_id = formData.get("category_id");
    const description = formData.get("description");
    const price = formData.get("price");
    const product_image = images;
    const stock = formData.get("stock");
    const title = formData.get("title");

    const values = {
      id: productData?._id,
      category_id,
      description,
      price,
      product_image,
      stock,
      title,
      variants,
    };
    mutation.mutate(values);
  };

  const onDelete = () => {
    deleteMutation.mutate(
      { id },
      {
        onSuccess: () => {
          showSuccessToast("Product deleted successfully");
          queryClient.invalidateQueries("products");
          window.location.href = "/products";
        },
        onError: (e) => {
          showErrorToast(e.message);
        },
      }
    );
  };

  return (
    <div className="p-5 font-Neurial">
      <div className="flex flex-col gap-5 mb-16">
        <div className="flex items-center gap-3">
          <BiChevronLeft
            className="text-[#070E05] text-[25px] cursor-pointer"
            onClick={() => {
              navigate(`/products`);
            }}
          />
          <div className="font-Neurial font-bold text-[20px] text-[#070E05]">
            View Product
          </div>
          <div className="ml-auto">
            <button
              onClick={onDelete}
              className="font-bold font-Neurial text-[12px] bg-[#EB5757] text-[#fff] px-3 py-3 rounded-[5px]"
            >
              {deleteMutation.isLoading ? "Deleting..." : "Delete Product"}
            </button>
          </div>
        </div>
      </div>

      <div className="rounded-[8px] p-5 bg-white">
        <div className="font-Neurial">
          <div className="flex flex-col gap-5 mb-16">
            <div className="flex gap-5">
              <div className="font-medium text-[17px] mt-3">
                Product Details
              </div>
              <div
                className={`rounded-full p-3 ${
                  productData?.stock > 0 ? "bg-[#9797971A]" : "bg-[#FF3A441A]"
                } w-[140px]`}
              >
                <p
                  className={`text-center ${
                    productData?.stock ? "text-[#000]" : "text-[#EB5757]"
                  }`}
                >
                  {productData?.stock > 0 ? "In Stock" : "Out of Stock"}
                </p>
              </div>
            </div>
            <form className="" onSubmit={onFinish}>
              <div className="flex w-full gap-10">
                <div className="w-1/2 flex flex-col gap-4">
                  {formData.map((v, k) => {
                    return (
                      <div key={k} className="space-y-1">
                        <div className="text-[#181819E5] text-[14px]">
                          {v.title}
                        </div>
                        <div className="">
                          {v.type == 1 ? (
                            <input
                              className="w-full text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[45px] px-4"
                              placeholder={v.placeholder}
                              name={v.name}
                              defaultValue={v.defaultValue}
                            />
                          ) : v.type == 3 ? (
                            <textarea
                              className="w-full text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[200px] p-4 resize-none"
                              placeholder={v.placeholder}
                              name={v.name}
                              defaultValue={v.defaultValue}
                            ></textarea>
                          ) : (
                            <select
                              defaultValue={v.defaultValue}
                              name={v.name}
                              className="w-full text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent outline-none rounded-lg h-[50px] px-4"
                            >
                              {v.options.map((d, k) => {
                                return (
                                  <option key={k} value={d._id}>
                                    {d.name}
                                  </option>
                                );
                              })}
                            </select>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="w-1/2 flex flex-col justify-between">
                  <div className="space-y-7">
                    <div className="space-y-3">
                      <div className="text-[#333333] font-medium text-[14px]">
                        Product Images
                      </div>
                      <UploadImages setImages={setImages} />
                    </div>
                    <div className="space-y-3">
                      <div className="text-[#333333] font-medium text-[14px] flex items-center justify-between">
                        <span>Variants</span>
                        <div
                          onClick={() =>
                            setVariants((prev) => [
                              ...prev,
                              { name: "", value: "", quantity: 0 },
                            ])
                          }
                          className="font-bold cursor-pointer font-Neurial text-[12px] bg-[#2121F11A] text-dark px-2 py-1 rounded-[5px]"
                        >
                          Add Variant
                        </div>
                      </div>
                      {variants.map((variant, ind) => (
                        <div
                          key={ind}
                          className="flex items-center gap-3 w-full"
                        >
                          <input
                            className="text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[45px] px-4 w-2/5"
                            placeholder="Variant Name e.g size"
                            name="variantName"
                            value={variant.name}
                            onChange={(e) =>
                              setVariants((prev) =>
                                prev.map((item, i) =>
                                  i === ind
                                    ? { ...item, name: e.target.value }
                                    : item
                                )
                              )
                            }
                          />
                          <input
                            className="text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[45px] px-4 w-2/5"
                            placeholder="Value. e.g medium"
                            value={variant.value}
                            onChange={(e) =>
                              setVariants((prev) =>
                                prev.map((item, i) =>
                                  i === ind
                                    ? { ...item, value: e.target.value }
                                    : item
                                )
                              )
                            }
                          />
                          <input
                            className="text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[45px] px-4 w-1/5"
                            placeholder="Qty."
                            type="number"
                            min={0}
                            value={variant.qty}
                            onChange={(e) =>
                              setVariants((prev) =>
                                prev.map((item, i) =>
                                  i === ind
                                    ? { ...item, qty: e.target.value }
                                    : item
                                )
                              )
                            }
                          />
                          <BiMinusCircle
                            size={25}
                            className="cursor-pointer"
                            color="red"
                            onClick={() =>
                              setVariants((prev) =>
                                prev.filter((_, i) => i !== ind)
                              )
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="ml-auto">
                    <button
                      className={`bg-dark text-white rounded-[5px] px-3 py-2 font-bold text-[15px] ${
                        mutation.isLoading ? "opacity-50 animate-pulse" : ""
                      }`}
                      type="submit"
                    >
                      {mutation.isLoading ? "Editing..." : "Edit Product"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProduct;
